/** Mandatory check in step 1: popup when the job ad has gaps. */
const wizJobGateEN = {
  wizGateTitle: 'The job ad still has gaps',
  wizGateIntro:
    '{{count}} points are missing. Complete the ad so SAIA finds better matching candidates and writes more precise messages.',
  wizGateIntroOne:
    'One point is missing. Complete the ad so SAIA finds better matching candidates and writes more precise messages.',
  wizGatePlaceholders:
    'Your additions still contain placeholders in square brackets, e.g. "[enter range]". Replace them with real details or delete them – otherwise they go into the campaign as they are.',
  wizGateHint:
    'You do not have to fix everything: "Skip" continues right away, and you can still adjust the ad later.',
  wizGateAmend: 'Complete the ad',
  wizGateProceed: 'Skip further optimisation',
  wizGateCheckRequired: 'Please check the ad first.',
  wizGateLocationRequired: 'Please say where the job is located (or that it is 100% remote) first.',
  wizLocationTitle: 'Where is the job located?',
  wizLocationHint:
    'Required: without a location the search cannot find matching candidates. If the job is fully remote, say so here.',
  wizLocationPlaceholder: 'e.g. Cologne',
  wizLocationSubmit: 'Apply',
  wizLocationRemote: 'The job is 100% remote',
  wizGateRetry: 'Try again',
  wizGateSkip: 'Continue without check',
  wizGateCheckFailedMany:
    'The check was unreachable several times. You can try again or continue without it.',
  wizGateCheckFailed: 'The check failed – please try again.',
};
export default wizJobGateEN;
